import type { FaireProductEntity } from "../../entity_types/product";

export const p_39nedw9krq: FaireProductEntity = {
  token: "p_39nedw9krq",
  type: "product",
  name: "Hawaii Big Island Necklace - Solid 14kt",
  brandToken: "b_ek5cbm3l",
  brandName: "Imi jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/4bdcff00f06dfd972767632b88b7598c334580bd1e825811b9ed8cff25495b9a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed8f5a971e86264d8a4c3d731120717ca7661599f57dc5b5d804213c583f979c.jpeg",
  ],
  priceDollars: 381,
  description:
    '\nRepresent your Hawaiian island pride with our original Big Island necklace\n\nPerfect for every day wear \n\nYellow gold 16-18" long \n\nWhite gold 16" or 18"\n\nApproximately 1/4" charm\n\nSolid 14 karat gold\n\n\n\n\n \n',
  tags: [],
  msrpDollars: 762,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:17.333Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
